import _ from '@lodash';
import { Divider, withStyles, CircularProgress, Typography, LinearProgress } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import AgendamentoEdicaoApp from "app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp";
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { Bar, Doughnut } from "react-chartjs-2";

const md = new MobileDetect(window.navigator.userAgent);


const styles = theme => ({
    defaultColor: {
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        textDecoration: "none !important",
        "&:hover": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        },
        "&:focus": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        }
    },
    box: {
        border: "1px solid " + theme.palette.divider
    },
    contrastBackground: {
        backgroundColor: theme.palette.background.paper,
    },
    bgColor: {
        height: 6,
        "& > div ": {
            backgroundColor: "#00D935",
        }
    }
});

class NaoRecebidoCard extends XAPPComponent {

    render() {
        const { data, openDialog, classes, xappRouteParams, callback } = this.props;
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        return (
            <React.Fragment>
                <AgendamentoEdicaoApp
                    xappRouteParams={xappRouteParams}
                    callback={callback}
                    className="w-full"
                    view={"Default"}
                    isDialog={true}
                    key={"Agendamento_" + data.idagendamento}
                    tipo={1}
                    idagendamento={data.idagendamento}
                >
                    <div
                        className={clsx("flex flex-col md:flex-row w-full min-h-48 mb-8 cursor-pointer", classes.contrastBackground)}
                        key={"Agendamento_" + data.dataemissao}
                        style={{ borderLeft: `8px solid ${data.faturamentofuturo === 1 ? "#F7C201" : "#FF7372"}` }}
                    >
                        <div className="flex w-full">
                            <div className={clsx(classes.box, "flex items-center w-full xs:py-8 border-b-0 md:border-b-1 md:border-r-0")}>
                                <span className={clsx("flex flex-col w-full text-center")}>{data.dataemissao}</span>
                            </div>
                            <div className={clsx(classes.box, "flex items-center w-full xs:py-8 border-b-0 md:border-b-1 md:border-r-0")}>
                                <span className={clsx("flex flex-col w-full text-left px-12")}>{data.agendamentonome}</span>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className={clsx(classes.box, "flex items-center w-full xs:py-8 border-b-0 md:border-b-1 md:border-r-0")}>
                                <span className={clsx("flex flex-col w-full text-right whitespace-no-wrap px-12")}>{formatter.format(data.valorpendente)}</span>
                            </div>
                            <div className={clsx(classes.box, "flex items-center w-full xs:py-8 border-b-0 md:border-b-1 md:border-r-0")}>
                                <span className={clsx("flex flex-col w-full text-center")}>{data.status}</span>
                            </div>
                        </div>
                    </div>
                </AgendamentoEdicaoApp>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(NaoRecebidoCard);
